import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pr-5 pl-5 pb-5" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Loading records, please wait... ")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, " 查看會議 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_Column = _resolveComponent("Column")!
  const _component_n_tag = _resolveComponent("n-tag")!
  const _component_EyeSharp = _resolveComponent("EyeSharp")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ParticipantModal = _resolveComponent("ParticipantModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_space, {
      justify: "space-between",
      class: "p-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_form, {
          model: _ctx.recordTimeRange,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_date_picker, {
              value: _ctx.recordTimeRange.data,
              "onUpdate:value": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.recordTimeRange.data) = $event)),
                _ctx.updateDatePicker
              ],
              type: "daterange",
              size: "large",
              actions: null,
              "close-on-select": true,
              separator: "To"
            }, null, 8, ["value", "onUpdate:value"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_DataTable, {
        value: _ctx.data,
        ref: "data_dt",
        dataKey: "EventHeaderId",
        loading: _ctx.loading,
        paginator: true,
        rows: 10,
        rowHover: true,
        resizableColumns: true,
        columnResizeMode: "fit",
        class: "p-datatable-sm",
        stripedRows: ""
      }, {
        loading: _withCtx(() => [
          _hoisted_2
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            header: "ID",
            sortable: true,
            style: {"width":"5rem"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.index+1), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "Title",
            header: "標題",
            sortable: true,
            style: {"width":"25rem"}
          }),
          _createVNode(_component_Column, {
            field: "Status",
            header: "狀態",
            style: {"width":"8rem"},
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.Status == _ctx.ParamEventStatus.Close)
                ? (_openBlock(), _createBlock(_component_n_tag, {
                    key: 0,
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.statusData.find((s) => s.Value == slotProps.data.Status)
            ?.Name ?? ""), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (slotProps.data.Status == _ctx.ParamEventStatus.Open)
                ? (_openBlock(), _createBlock(_component_n_tag, {
                    key: 1,
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.statusData.find((s) => s.Value == slotProps.data.Status)
            ?.Name ?? ""), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (slotProps.data.Status == _ctx.ParamEventStatus.Cancel)
                ? (_openBlock(), _createBlock(_component_n_tag, {
                    key: 2,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.statusData.find((s) => s.Value == slotProps.data.Status)
            ?.Name ?? ""), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "StartUTCDateTime",
            style: {"width":"10rem"},
            header: "會議日期",
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.Status == _ctx.ParamEventStatus.Cancel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                : (slotProps.data.IsResolution == _ctx.ParamIsResolution.NotYet)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString("日期未決議")))
                  : (_ctx.localdayjs( slotProps.data.StartUTCDateTime).isAfter(_ctx.localdayjs( '0001-01-01T00:00:00')))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.localdayjs( slotProps.data.StartUTCDateTime).format(" YYYY/MM/DD (ddd)")), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6))
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "Location",
            header: "地點",
            style: {"width":"10rem"},
            sortable: true
          }),
          _createVNode(_component_Column, { header: "檢視" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_n_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_n_button, {
                    type: _ctx.info,
                    secondary: "",
                    onClick: ($event: any) => (_ctx.onDetail(slotProps.data))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_n_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_EyeSharp)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["type", "onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "loading"])
    ]),
    _createVNode(_component_ParticipantModal, {
      showModal: _ctx.showViewModal,
      onModalClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showViewModal = $event)),
      eventColor: _ctx.stringColor(_ctx.modalEventID, false),
      eventID: _ctx.modalEventID,
      statusHeaders: _ctx.groupHeaders,
      eventType: _ctx.EventType.Record
    }, null, 8, ["showModal", "eventColor", "eventID", "statusHeaders", "eventType"])
  ], 64))
}